import { createContext } from 'react';

import { TripExtra } from './types';

export const tripExtraContext = createContext<TripExtra>(undefined as unknown as TripExtra);
